import styled from 'styled-components';
import {
  PaymentMethodForm,
  PaymentMethodFormWithMicrodepositsProps,
} from '@perch-labs/shrike';

interface Props extends PaymentMethodFormWithMicrodepositsProps {
  ready: boolean;
}

export const StyledPaymentMethodForm = styled(PaymentMethodForm)<Props>`
  padding: 0;
  ${props => !props.ready && 'display: none;'}

  #payment-method-footer {
    flex-direction: row-reverse;

    button {
      width: auto;
      margin: 0 0 0 16px;
    }
  }
`;
